import { Directive, ElementRef, Input } from '@angular/core';
import { BehaviorSubject, Subject, filter, fromEvent, merge, switchMap, takeUntil } from 'rxjs';

@Directive({
  selector: '[stopPropagation]',
})
export class StopPropagationDirective {

  readonly #destroy = new Subject<void>()


  readonly eventsSubject = new BehaviorSubject<string[]>(['click'])
  @Input() get events() {
    return this.eventsSubject.value
  }
  set events(value) {
    this.eventsSubject.next(value)
  }


  constructor(private readonly _elementRef: ElementRef) {

  }

  ngAfterViewInit() {


    this.eventsSubject.pipe(
      filter(Boolean),
      switchMap((events) => merge(...events.map((event) => fromEvent<Event>(this._elementRef.nativeElement, event)))),
      takeUntil(this.#destroy)
    )
      .subscribe((evParams) => {
        evParams.stopPropagation();
      })

  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
